module.exports = __webpack_public_path__ + "static/img/11.6355ca3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/11.png
// module id = +tWt
// module chunks = 0